/**
 * Public-document (guest access) query keys (Server-state rebuild, P4-tail). Preserves
 * today's exact values.
 */
export const publicDocumentKeys = {
  base: (documentId: string, accessCode: string) =>
    ['public-document', documentId, accessCode] as const,
  attempt: (documentId: string, accessCode: string) =>
    ['public-document', 'attempt', documentId, accessCode] as const,
} as const;
